<template>
  <v-footer
    id="footer"
    padless
    block
    primary
    class="footer pt-2 primary"
    role="contentinfo"
  >
    <v-flex
      xs12
      sm12
      md12
      lg12
      column
    >
      <v-card
        :elevation="0"
        secondary
        class="footer-card"
      >
        <v-card-title
          class="accent d-flex align-center"
          role="heading"
          aria-level="2"
        >
          <h2 class="accent d-flex align-center">
            <strong class="subheading text-subtitle-1">
              {{ "Follow our social media, we will keep you updated" }}
            </strong>
          </h2>

          <v-spacer />

          <div
            role="group"
            aria-label="Social media links"
          >
            <v-btn
              v-for="community in communities"
              :key="community.id"
              class="mx-4"
              dark
              icon
              :aria-label="`Open ${community.name} in new tab`"
              @click="goTo(community.link)"
            >
              <v-icon
                size="24px"
                :title="community.name"
                aria-hidden="true"
              >
                {{ community.icon }}
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-divider aria-hidden="true" />

        <v-card-text
          class="py-2 white--text text-center"
          aria-label="Copyright Notice"
        >
          {{ new Date().getFullYear() }} —
          <strong>RedArc Studio Ltd</strong>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-footer>
</template>

<script>
import communities from "@/constants/communities";

export default {
  name: 'FooterComp',
  data() {
    return {
        communities: communities.list,
    }
  },
  methods: {
    goTo(link) {
        window.open(link);
    },
  }
};
</script>

<style lang="scss" scoped>
.footer {
    padding-bottom: 5rem;
    position: relative!important;
}

</style>

